import {MatDialog} from "@angular/material/dialog";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {
  EditThresholdComponent,
  EditThresholdDialogData
} from "../components/main-view/update-validation-threshold/edit-threshold/edit-threshold.component";
import {
  AddThresholdConfirmDialogComponent,
  AddThresholdConfirmDialogData
} from "../components/main-view/update-validation-threshold/add-threshold-confirm-dialog/add-threshold-confirm-dialog.component";
import {
  DeleteThresholdConfirmDialogComponent,
  DeleteThresholdConfirmDialogData
} from "../components/main-view/update-validation-threshold/delete-threshold-confirm-dialog/delete-threshold-confirm-dialog.component";
import { RejectResourcePermissionsDialogComponent } from "../components/main-view/manage-permissions-wrapper/reject-resource-permissions-dialog/reject-resource-permissions-dialog.component";
import {
  EditTransitTimeConfigComponent,
  EditTransitTimeConfigData
} from "../components/main-view/transit-time-configuration/edit-transit-time-config/edit-transit-time-config.component";


@Injectable()
export class DialogService {
  constructor(
    private dialog: MatDialog
  ) {
  }

  /**
   * return true/false based on user response
   * @param data {@link AddThresholdConfirmDialogData}
   */
  public openAddThresholdConfirmDialog(data: AddThresholdConfirmDialogData): Observable<boolean> {
    return this.dialog
      .open(AddThresholdConfirmDialogComponent, {
        data
      })
      .afterClosed();
  }

  /**
   * Gets new threshold from the user.
   *
   * @param data {@link EditThresholdDialogData}
   */
  public openEditThresholdDialog(data: EditThresholdDialogData): Observable<number> {
    return this.dialog.open(EditThresholdComponent, {
      data
    }).afterClosed()
  }

  /**
   * Gets confirmation from user for deleting threshold.
   *
   * @param data {@link DeleteThresholdConfirmDialogData}
   */
  public openDeleteThresholdConfirmDialog(data: DeleteThresholdConfirmDialogData): Observable<boolean> {
    return this.dialog.open(DeleteThresholdConfirmDialogComponent, {
      data
    }).afterClosed()
  }

  /**
   * Gets reject requested user permission reason from Admin.
   */
  public openRejectResourcePermissionsDialog(data: any): Observable<boolean> {
    return this.dialog.open(RejectResourcePermissionsDialogComponent, {
      data
    }).afterClosed()
  }

  /**
   * Opens the Transit Time Configuration edit dialog. Resolves with
   * { saved: true, message } on a successful update, or undefined otherwise.
   */
  public openEditTransitTimeConfigDialog(data: EditTransitTimeConfigData): Observable<any> {
    return this.dialog.open(EditTransitTimeConfigComponent, {
      data,
      width: '560px',
      disableClose: true
    }).afterClosed()
  }
}
